module.exports = __webpack_public_path__ + "img/s2.51d9766e.png";